import { render, staticRenderFns } from "./SGShardedClusterStatus.vue?vue&type=template&id=78021ea7&scoped=true"
import script from "./SGShardedClusterStatus.vue?vue&type=script&lang=js"
export * from "./SGShardedClusterStatus.vue?vue&type=script&lang=js"
import style0 from "./SGShardedClusterStatus.vue?vue&type=style&index=0&id=78021ea7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78021ea7",
  null
  
)

export default component.exports